'use strict';

var Joi = require('joi');
var experimentsSchema_model = require('../utils/experimentsSchema.model.js');

function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }

var Joi__default = /*#__PURE__*/_interopDefault(Joi);

var SignupUserLogin = Joi__default["default"].object().keys({
  name: Joi__default["default"].string().optional().description('Creator Full Name'),
  username: Joi__default["default"].string().optional().description('Creator Username'),
  page_number: Joi__default["default"].number().min(1).optional().description('Step in Onboarding Wizard'),
  email: Joi__default["default"].string().email({
    tlds: {
      allow: false
    }
  }).optional().description('Creator email'),
  experiments: experimentsSchema_model,
  tier: Joi__default["default"].string().valid('tier_1', 'tier_0').optional().description('Tier of creator'),
  created_at: Joi__default["default"].date().required().description('Datetime event was sent')
}).description('This event fires when the user completes the signup step and officially makes an account.').meta({
  name: 'SignupUserLogin',
  filename: 'signup:user_login.model'
});
var SignupUserLogin$1 = SignupUserLogin;

module.exports = SignupUserLogin$1;
//# sourceMappingURL=user_login.model.js.map
